import { createReducer, on } from '@ngrx/store';
import * as QuoteActions from './mini-quote-cart.actions';

export const initialState = {
  cartData: null
};

export const quoteReducer = createReducer(
  initialState,
  on(QuoteActions.loadQuoteCartSuccess, (state, action) => {
    return {
      ...state,
      cartData: action.data
    };
  })
);